import { render } from "./SchoolTypeDistribution.vue?vue&type=template&id=0d38d1f3"
import script from "./SchoolTypeDistribution.vue?vue&type=script&lang=js"
export * from "./SchoolTypeDistribution.vue?vue&type=script&lang=js"
script.render = render

export default script